module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-0073d390f16f266e0448d00d706912ed.webp";